import { W as WuiEmptyState$1, d as defineCustomElement$1 } from './p-By0p9lYd.js';

const WuiEmptyState = WuiEmptyState$1;
const defineCustomElement = defineCustomElement$1;

export { WuiEmptyState, defineCustomElement };
